// extracted by mini-css-extract-plugin
module.exports = {"toast":"VpnConnectionNotice_toast__ozWrs","attribution":"VpnConnectionNotice_attribution__gN9zo"};